import React from "react";
import { useTaskFlow } from "../ai-task-button";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogTitle } from "../../../../components/ui/dialog";
import { Button } from "../../../../components/ui/button";
import { SearchIcon, ExternalLinkIcon } from "lucide-react";
import { ResearchResponse } from "../../../../data/types/ai-task-types";

interface ResearchFlowProps {
    data: ResearchResponse;
}

export function ResearchFlow({ data }: ResearchFlowProps) {
    const { setTaskComplete, setCancel } = useTaskFlow();

    const handleConfirm = () => {
        const searchUrl = `https://www.perplexity.ai/search?q=${data.data.searchQuery}`;
        window.open(searchUrl, "_blank");
        setTaskComplete();
    };

    const handleCancel = () => {
        setCancel();
    };

    return (
        <Dialog open={true} onOpenChange={() => handleCancel()}>
            <DialogContent>
                <DialogTitle className="flex flex-row items-center">
                    <SearchIcon className="me-2 h-5 w-5" />
                    Run Research
                </DialogTitle>

                <div>
                    <p className="text-sm text-muted-foreground">
                        This search query includes your project context and will be sent to{" "}
                        <a
                            href="https://www.perplexity.ai/"
                            target="_blank"
                            className="text-primary hover:underline"
                            rel="noreferrer"
                        >
                            Perplexity
                        </a>
                        .
                    </p>
                </div>

                <div className="flex flex-col gap-1">
                    <span className="text-sm font-medium">Search</span>
                    <div className="mt-1 rounded-md border bg-muted/50 p-3 text-sm">{data.data.searchQuery}</div>
                </div>

                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </DialogClose>
                    <Button onClick={handleConfirm}>
                        <ExternalLinkIcon className="me-2 h-4 w-4" />
                        Open Perplexity
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
